import { TripCalculator } from './TripCalculator';
import { SEO } from './SEO';
import { StructuredData, getBreadcrumbSchema } from './StructuredData';

export function Book() {
  return (
    <div className="min-h-screen pt-20 bg-primary">
      <SEO 
        title="Book Transport Services Johannesburg | Skiva Africa Tours"
        description="Book professional transport with Skiva Africa Tours, including airport transfers, private transportation, corporate travel, group transport and tourism services across Johannesburg and South Africa."
        canonical="https://skivatours.com/book"
      />
      <StructuredData 
        data={getBreadcrumbSchema([
          { name: 'Home', url: 'https://skivatours.com/' },
          { name: 'Book', url: 'https://skivatours.com/book' }
        ])} 
      />
      <TripCalculator />
    </div>
  );
}
